import React from "react";

import { Agreement } from "@is/types";

import AgreementItem from "./AgreementItem";
import css from "./Agreements.module.css";

type Props = {
  checkoutAgreements: Agreement[];
  onOpenExternalPage: (src: string) => void;
  onToggleCheckbox: (id: string) => void;
  showPaymentErrorMessage: boolean;
};

const Agreements = ({
  checkoutAgreements,
  onOpenExternalPage,
  onToggleCheckbox,
  showPaymentErrorMessage,
}: Props) => (
  <div className={css.container}>
    <div className={css.wrapper}>
      {checkoutAgreements.map((agreement) => (
        <AgreementItem
          key={agreement.id}
          agreement={agreement}
          onOpenExternalPage={onOpenExternalPage}
          onToggleCheckbox={onToggleCheckbox}
          showPaymentErrorMessage={showPaymentErrorMessage}
        />
      ))}
    </div>
  </div>
);
export default Agreements;
